import isNil from 'lodash/isNil'
import React from 'react'
import { HorizontalStack, Icon, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import type { ProductQuantityProps } from '@ztechapps/webui.contract'
import { QuantityWithUom } from '../QuantityWithUom/QuantityWithUom'

export const ProductQuantity = ({
  quantityOnHand,
  requiredComputedQuantityOnHand,
  computedQuantityOnHand,
  hasSubComponents,
  baseUomSymbol,
  decimalPrecision,
}: ProductQuantityProps) => {
  return (
    <HorizontalStack gap={1}>
      <QuantityOnHand
        quantityOnHand={quantityOnHand}
        baseUomSymbol={baseUomSymbol}
        decimalPrecision={decimalPrecision}
      />

      <ShowIf condition={!isNil(requiredComputedQuantityOnHand) && hasSubComponents === true}>
        <RequiredComputedQuantityOnHand
          requiredComputedQuantityOnHand={requiredComputedQuantityOnHand}
          baseUomSymbol={baseUomSymbol}
          decimalPrecision={decimalPrecision}
        />
      </ShowIf>

      <ShowIf condition={!isNil(computedQuantityOnHand) && hasSubComponents === true}>
        <ComputedQuantityOnHand
          computedQuantityOnHand={computedQuantityOnHand}
          baseUomSymbol={baseUomSymbol}
          decimalPrecision={decimalPrecision}
        />
      </ShowIf>
    </HorizontalStack>
  )
}

type QuantityProps = {
  baseUomSymbol: string
  decimalPrecision: number
}

export const QuantityOnHand = ({
  quantityOnHand,
  baseUomSymbol,
  decimalPrecision,
}: { quantityOnHand: number } & QuantityProps) => {
  return (
    <TooltipPopOver tooltipBody="Quantity on hand - The actual/physical quantity for this product for all location.">
      <div>
        <Icon name={'box'} />{' '}
        <QuantityWithUom quantity={quantityOnHand ?? 0} symbol={baseUomSymbol} decimalPrecision={decimalPrecision} />
      </div>
    </TooltipPopOver>
  )
}

export const RequiredComputedQuantityOnHand = ({
  requiredComputedQuantityOnHand,
  baseUomSymbol,
  decimalPrecision,
}: { requiredComputedQuantityOnHand: number } & QuantityProps) => {
  return (
    <TooltipPopOver tooltipBody="Computed quantity on hand (required from bill of materials only) - This is the maximum quantity that can be built using ALL available sub-component's quantity on hand, and considering only the required product from bill of materials.">
      <div>
        <Icon name={'boxes-packing'} />{' '}
        <QuantityWithUom
          quantity={requiredComputedQuantityOnHand ?? 0}
          symbol={baseUomSymbol}
          decimalPrecision={decimalPrecision}
        />
      </div>
    </TooltipPopOver>
  )
}

export const ComputedQuantityOnHand = ({
  computedQuantityOnHand,
  baseUomSymbol,
  decimalPrecision,
}: { computedQuantityOnHand: number } & QuantityProps) => {
  return (
    <TooltipPopOver tooltipBody="This is the maximum quantity that can be built using ALL available sub-component's quantity on hand.">
      <div>
        <Icon name={'tag'} />{' '}
        <QuantityWithUom
          quantity={computedQuantityOnHand ?? 0}
          symbol={baseUomSymbol}
          decimalPrecision={decimalPrecision}
        />
      </div>
    </TooltipPopOver>
  )
}
